(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    window.LC_API = window.LC_API || {};
    window.LC_API.on_ticket_created = function onLivechatTicketCreated() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            eventCategory: 'Enterprise',
            eventAction: 'chat-message-sent',
            eventLabel: window.location.href,
        });
    };
    document.querySelector('.chat-trigger').addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof window.LC_API.is_loaded === 'function' && window.LC_API.is_loaded()) {
            window.LC_API.hide_chat_window();
            window.LC_API.open_chat_window();
        }
    });
}));
